<div class="container">
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.CreateHeader' | translate }}" [selected]="isFormOpen">
        <form [formGroup]="createForm">
          <div class="p-fluid formgrid grid">

            <div class="field col-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.Facility' | translate }}</p>
              <div class="item">{{facilityCode}}</div>
            </div>

            <div class="field col-3  laas-calendar">
              <laas-calendar #departureDay [title]="'CarSequenceMaintenance.Form.Departure.DepartureDay'"
                [enableMaxDateIsToday]="false" [selectionMode]="'single'" appendTo="body" [requiredStar]="true"
                (onDateChange)="dateOnChange($event,'departureDay')">
              </laas-calendar>
              <div *ngIf="(submitted && createForm?.controls?.departureDay?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="field col-3" *ngIf="isCNFacility">
              <span class="requiredStart">*</span><label>{{ 'BookingSearch.Form.CarSeq' | translate}}</label>
                <div class="item">
                  <p-dropdown
                    formControlName="carSeqNo"
                    appendTo="body"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [options]="carSeqListSCDG"></p-dropdown>
                </div>
                <div *ngIf="(submitted && createForm?.controls?.carSeqNo?.errors?.required )" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
            </div>

            <div class="field col-3" *ngIf="!isCNFacility">
              <span class="requiredStart">*</span><label>{{ 'BookingSearch.Form.CarSeq' | translate}}</label>
              <div class="item">
                <p-dropdown
                  formControlName="carSeqNo"
                  appendTo="body"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="carSeqListLK" ></p-dropdown>
              </div>
              <div *ngIf="(submitted && createForm?.controls?.carSeqNo?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="field col-3">
              <span class="requiredStart">*</span><label>{{ 'BookingSearch.Form.DeliveryCategory' | translate }}</label>
              <div class="item">
                <p-dropdown formControlName="deliveryCategory"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true" appendTo="body"
                  [options]="deliveryCategoryList"></p-dropdown>
              </div>
              <div *ngIf="(submitted && createForm?.controls?.deliveryCategory?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>
            <div class="field col-3">
              <label>{{ 'ContainerManagement.SubTable.TrPaymentBy' | translate }}</label>
              <div class="item">
                <p-dropdown
                  [filter]="true"
                  appendTo="body"
                  filterBy="label,value"

                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="forwarderCodeOptions"
                  [(ngModel)]="trPaymentBy"
                  [ngModelOptions]="{standalone: true}"
                ></p-dropdown>
              </div>
            </div>
            <div class="field col-3">
              <label>{{ 'ContainerManagement.SubTable.CarType' | translate }}</label>
              <div class="item">
                <laas-car-type-selector
                formControlName="createCarType"
                [facility]="facilityCode"></laas-car-type-selector>
              </div>
            </div>
            <div class="field col-3">
              <label>{{ 'ContainerManagement.SubTable.PlateNo' | translate }}</label>
              <div class="item">
                <input pInputText
                       [attr.maxlength]="30"
                       formControlName="licensePlateNo"/>
              </div>
            </div>
            <div class="field col-3" *ngIf="isCNFacility">
              <label>{{ 'ContainerManagement.MainTable.PickUpType' | translate }}</label>
              <div class="item">
                <p-dropdown formControlName="isMValue" [(ngModel)]="mValue" appendTo="body"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [options]="mvalueOptions"></p-dropdown>
              </div>
            </div>

            <div class="field col-3" *ngIf="isCNFacility && mValue === 'main'" >
              <label>{{ 'AllocationConstraint.Search.consigneeKey' | translate }}</label>
              <p-dropdown formControlName="consigneeKey" appendTo="body" [options]="consigneeKeyOption"
                [virtualScroll]="true" optionLabel="label" optionValue="value" [itemSize]="40" appendTo="body"
                [filter]="true" filterBy="value"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-dropdown>
            </div>

            <div class="field col-3" *ngIf="isCNFacility && mValue === 'main'">
              <span class="requiredStart">*</span><label>{{ 'ContainerManagement.MainTable.PickUp' | translate }}</label>
              <div class="item">
                <p-dropdown formControlName="pickupLocationCode" appendTo="body"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="awbAddressOptions"></p-dropdown>
              </div>
            </div>

            <div class="field col-3" *ngIf="isCNFacility && mValue === 'main'">
              <span class="requiredStart">*</span><label>{{ 'BookingSearch.Form.Forwarder' | translate }}</label>
              <div class="item">
                <p-dropdown formControlName="forwarder" optionLabel="optionDesc" optionValue="optionCode" appendTo="body"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [options]="bookingForwarderList"
                  [filter]="true" filterBy="optionDesc"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Add' | translate }}"
                (click)="createBtnClick()"
              ></button>
            </div>
          </div>


        </form>
      </p-accordionTab>
    </p-accordion>


    </p-card>

  </div>

    <p-dialog p-dialog header="Create Data success!" appendTo="body" [(visible)]="isShowContainerCodeList" [modal]="true"
      [draggable]="false" [resizable]="false" [dismissableMask]="true" [style]="{width: '25%'}" max-height="500">
      <div class="p-fluid formgrid grid">
        <div class="field col-12">
          <label> {{containerCode}}</label>
        </div>
      </div>
    </p-dialog>
